import immutable from 'immutable';
import url from 'url';

const OPEN = '@@Navi/openPage';

const naviUrl = (state) => {
	const params = state.navi.params;
	if (params.filter) {
		params.filter = JSON.stringify(params.filter);
	}
	const s = url.format({
		pathname: '/' + state.navi.page,
		query: params
	});
	return s;
};

const initialState = {
	page: 'firm',
	params: {}
};

export default function reducer(state = initialState, action = {}) {
	switch (action.type) {

		case OPEN:
			var navi = {
				page: action.page,
				params: action.params
			};
			return {...navi};

		default:
			return state;
	}
}

export function openPage(page, params = {}) {
	return {
		type: OPEN,
		page,
		params,
		url: naviUrl
	};
}


// WEBPACK FOOTER //
// ./src/redux/modules/navi.js